import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Card } from 'material-ui/Card'
import { Row, Col } from 'pui-react-grids'
import FontIcon from 'material-ui/FontIcon'
import { Table, TableBody, TableRow, TableRowColumn } from 'material-ui/Table'
import { themeColors } from '../styles/theme'
import MonetizationOn from 'material-ui/svg-icons/editor/monetization-on'
import { AFFIDABILITA_ICON_NAME } from '../styles/icons'
import Autorenew from 'material-ui/svg-icons/action/autorenew'
import Room from 'material-ui/svg-icons/action/room'
import RaisedButton from 'material-ui/RaisedButton'
import { checkUserCanSwap } from '../utils'
import Footer from '../common/Footer'

const styles = {
  titleStyle: {
    mariginBottom: '0px',
    fontWeight: 'bold',
    marginBottom: 0,
    fontSize: 24,
    lineHeight: '36px',
    color: themeColors.positive,
  },
  mediaStyle: {
    margin: 10,
  },
  profileTableLeft: {
    color: themeColors.positive,
    fontSize: 16,
    textOverflow: 'clip',
    whiteSpace: 'normal',
  },
  profileTableRight: {
    color: themeColors.energized,
    fontSize: 16,
    textOverflow: 'clip',
    whiteSpace: 'normal',
    paddingLeft: 0,
  },
  profileListRight: {
    paddingTop: 5,
    marginRight: 60,
    color: themeColors.energized,
  },
  positionStyle: {
    paddingTop: 0,
    marginTop: 0,
    color: themeColors.energized,
  },
  profileTr: {
    height: 48,
    display: 'table-row',
    width: '100%',
  },
  profileTdLeft: {
    display: 'table-cell',
    verticalAlign: 'inherit',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    paddingLeft: 24,
    paddingRight: 24,
    borderCollapse: 'collapse',
    borderSpacing: '0px',
    fontWeight: 'bold',
    width: '50%',
    color: themeColors.positive,
  },
  profileTdRight: {
    display: 'table-cell',
    width: '50%',
    textAlign: 'left',
    paddingLeft: 0,
    verticalAlign: 'inherit',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    wordBreak: 'break-all',
    textOverflow: 'ellipsis',
    paddingTop: 8,
    color: themeColors.energized,
  },
  tableRow: {
    height: 'none',
    minHeight: '48px',
  },
}

const iconStyle = {
  positive: {
    position: 'relative',
    top: 6,
    color: themeColors.positive,
    marginRight: 15,
  },
  energized: {
    position: 'relative',
    top: 5,
    color: themeColors.energized,
  },
}

const Profile = ({ user }) => (
  <div className="padding">
    {!checkUserCanSwap(user) &&
      <Row>
        <Col md={24}>
          <Card
            style={{
              textAlign: 'center',
              padding: 10,
              marginBottom: 15,
              backgroundColor: themeColors.lightBackground,
            }}>
            <p>
              <span
                style={{ color: themeColors.secondary, fontWeight: 'bold' }}>
                ATTENZIONE
              </span>
              : completa i tuoi dati personali per poter effettuare scambi!
            </p>
          </Card>
        </Col>
      </Row>}

    <Row>
      <Col md={6}>
        <Card>
          <div className="padding" style={{ textAlign: 'center' }}>
            <h1 style={styles.titleStyle}>{user.username}</h1>
            <p style={styles.positionStyle}>
              {user.posizione &&
                <span>
                  <Room style={iconStyle.energized} />{user.posizione}
                </span>}
            </p>
            <RaisedButton
              containerElement={<Link to="/profile/edit" />}
              label="Modifica account"
              fullWidth={true}
              primary={true}
              style={{ marginBottom: 10, marginTop: 20 }}
              className="hidden-sm hidden-xs"
            />
            <RaisedButton
              containerElement={<Link to="/profile/change-password" />}
              label="Modifica password"
              fullWidth={true}
              secondary={true}
              className="hidden-sm hidden-xs"
              style={{ marginBottom: 10 }}
            />
            <RaisedButton
              containerElement={<Link to="/profile/delete-account" />}
              label="Cancella Account"
              fullWidth={true}
              backgroundColor={themeColors.evilred}
              labelColor={'#fff'}
              className="hidden-sm hidden-xs"
            />
          </div>
        </Card>
      </Col>
      <Col md={18}>
        <Card>
          <Table selectable={false}>
            <TableBody displayRowCheckbox={false}>
              <TableRow style={styles.tableRow}>
                <TableRowColumn
                  style={styles.profileTableLeft}
                  className="responsive-text">
                  Nome
                </TableRowColumn>
                <TableRowColumn
                  style={styles.profileTableRight}
                  className="responsive-text">
                  {user.firstname}
                </TableRowColumn>
              </TableRow>
              <TableRow style={styles.tableRow}>
                <TableRowColumn
                  style={styles.profileTableLeft}
                  className="responsive-text">
                  Cognome
                </TableRowColumn>
                <TableRowColumn
                  style={styles.profileTableRight}
                  className="responsive-text">
                  {user.lastname}
                </TableRowColumn>
              </TableRow>
              <TableRow style={styles.tableRow}>
                <TableRowColumn
                  style={styles.profileTableLeft}
                  className="responsive-text">
                  Email
                </TableRowColumn>
                <TableRowColumn
                  style={styles.profileTableRight}
                  className="responsive-text">
                  {user.email}
                </TableRowColumn>
              </TableRow>
              <TableRow style={styles.tableRow}>
                <TableRowColumn
                  style={styles.profileTableLeft}
                  className="responsive-text">
                  Indirizzo
                </TableRowColumn>
                <TableRowColumn
                  style={styles.profileTableRight}
                  className="responsive-text">
                  {user.address}
                </TableRowColumn>
              </TableRow>
              <TableRow style={styles.tableRow}>
                <TableRowColumn
                  style={styles.profileTableLeft}
                  className="responsive-text">
                  Telefono
                </TableRowColumn>
                <TableRowColumn
                  style={styles.profileTableRight}
                  className="responsive-text">
                  {user.telephone}
                </TableRowColumn>
              </TableRow>
              <TableRow style={styles.tableRow}>
                <TableRowColumn
                  style={styles.profileTableLeft}
                  className="responsive-text">
                  Città
                </TableRowColumn>
                <TableRowColumn
                  style={styles.profileTableRight}
                  className="responsive-text">
                  {user.city}
                </TableRowColumn>
              </TableRow>
              <TableRow style={styles.tableRow}>
                <TableRowColumn
                  style={styles.profileTableLeft}
                  className="responsive-text">
                  Provincia
                </TableRowColumn>
                <TableRowColumn
                  style={styles.profileTableRight}
                  className="responsive-text">
                  {user.district}
                </TableRowColumn>
              </TableRow>
              <TableRow style={styles.tableRow}>
                <TableRowColumn
                  style={styles.profileTableLeft}
                  className="responsive-text">
                  CAP
                </TableRowColumn>
                <TableRowColumn
                  style={styles.profileTableRight}
                  className="responsive-text">
                  {user.zip}
                </TableRowColumn>
              </TableRow>
            </TableBody>
          </Table>
          <table style={{ marginTop: 15, width: '100%' }}>
            <tbody style={{ padding: '20px' }}>
              <tr style={styles.profileTr}>
                <td style={styles.profileTdLeft} className="responsive-text">
                  <MonetizationOn style={iconStyle.positive} />eCoin
                </td>
                <td style={styles.profileTdRight} className="responsive-text">
                  {user.credito}
                </td>
              </tr>
              <tr style={styles.profileTr}>
                <td style={styles.profileTdLeft} className="responsive-text">
                  <FontIcon
                    className="material-icons"
                    style={iconStyle.positive}>
                    {AFFIDABILITA_ICON_NAME}
                  </FontIcon>
                  Affidabilità
                </td>
                <td style={styles.profileTdRight} className="responsive-text">
                  {Number(user.affidabilita * 100).toFixed()}%
                </td>
              </tr>
              <tr style={styles.profileTr}>
                <td style={styles.profileTdLeft} className="responsive-text">
                  <Autorenew style={iconStyle.positive} />Transazioni
                </td>
                <td style={styles.profileTdRight} className="responsive-text">
                  {user.transazioni}
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <div className="padding">
            <RaisedButton
              containerElement={<Link to="/profile/edit" />}
              label="Modifica account"
              fullWidth={true}
              primary={true}
              style={{ marginBottom: 10, marginTop: 20 }}
              className="hidden-md hidden-lg"
            />
            <RaisedButton
              containerElement={<Link to="/profile/change-password" />}
              label="Modifica password"
              style={{ marginBottom: 10 }}
              fullWidth={true}
              secondary={true}
              className="hidden-md hidden-lg"
            />
            <RaisedButton
              containerElement={<Link to="/profile/delete-account" />}
              label="Cancella Account"
              style={{ marginBottom: 10 }}
              fullWidth={true}
              backgroundColor={themeColors.evilred}
              labelColor={'#fff'}
              className="hidden-md hidden-lg"
            />
          </div>
        </Card>
      </Col>
    </Row>
    <Footer />
  </div>
)

export default connect(({ auth }) => ({ user: auth.user }))(Profile)



// WEBPACK FOOTER //
// ./src/pages/Profile.js